import {getUrlParams} from '../../../utils/common-utils';
import {ICheckinCheckoutDate} from './../../common/redux/types';
import {addDays} from '../../../utils/date-utils';
import {defaultRoomString} from './../../../config/app-config';
import {
  defaultCheckinOffset,
  defaultCheckoutOffset,
  parseUrlDateString,
} from './../../../utils/date-utils';
import {roomStringUtils} from '@ibibo/hotel-utils';

export const parseReviewPageUrlToConfig = url => {
  // vcid: '',
  let defaultCheckinDate = addDays(new Date(), defaultCheckinOffset);
  let defaultCheckoutDate = addDays(new Date(), defaultCheckoutOffset);

  let checkin: ICheckinCheckoutDate = {date: defaultCheckinDate};
  let checkout: ICheckinCheckoutDate = {date: defaultCheckoutDate};
  let roomString: string = defaultRoomString;
  let paxString: string = defaultRoomString;
  const {data, cc = ''} = getUrlParams(url);
  const decodedData = Buffer.from(data, 'base64') || '';
  const parsedData = JSON.parse(decodedData) || {};

  const {
    hc,
    vert,
    strQry,
    v,
    rtc,
    rpc,
    rtn,
    gseg,
    cot,
    gsv,
    fwdParams,
    newui,
    code,
    hmd,
    pay_mode,
    hOfferCode,
    hotelName,
    hotelArea,
    cityCode,
    gtv,
  } = parsedData;
  const destination = {_id: hc, n: hotelName, t: 'hotel'};
  const strQuery = strQry ? strQry.split('-') : [];
  if (strQry && strQuery.length > 3) {
    let ci = strQuery[2] || '';
    let co = strQuery[3] || '';
    paxString = strQuery.slice(4).join('-') || defaultRoomString;
    // roomString = roomStringUtils.oldRoomStrValidator(paxString);
    roomString = roomStringUtils.oldToNewRoomstring(paxString);
    if (ci && co) {
      checkin.date = parseUrlDateString(ci) || defaultCheckinDate;
      checkout.date = parseUrlDateString(co) || defaultCheckoutDate;
    }
  }

  return {
    input: {
      hc,
      vert,
      strQry,
      v,
      rtc,
      rpc,
      rtn,
      gseg,
      cot,
      gsv,
      fwdParams,
      newui,
      code,
      hmd,
      pay_mode,
      paxString,
      hOfferCode,
      hotelArea,
      cityCode,
      gtv,
    },
    checkin,
    checkout,
    roomString,
    destination,
  };
};
